import { useMutation, UseQueryOptions } from "react-query";
import { getConfig } from "../config";

async function updateRepair(data: RepairUpdate) {
  const { apiUrl, apiKey } = getConfig();
  let url = `${apiUrl}/repairs/${data.id}/`;
  const headers = {
    "X-Locker-Token": apiKey,
    "Content-Type": "application/json",
  };
  const response = await fetch(url, {
    headers,
    method: "PATCH",
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error("Network Error");
  }
  return response.json();
}

export function useUpdateRepair(options?: UseQueryOptions) {
  return useMutation(
    (data: RepairUpdate) => updateRepair(data),
    options as any
  );
}
